import Examination from './Examination.vue';

export default Examination;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/views/examination/index.ts